<template>
  <Card>
    <div slot="title" class="header font-hua">
      <h3>
        <span v-show="titleShow == 0">{{templateName}}</span>
        <el-input v-show="titleShow == 1" class="title-input" v-model="templateName" @keyup.enter="modifyTitle('save')"/>
      </h3>
      <el-button class="edit" icon="el-icon-edit" v-show="titleShow == 0 && !isDoctor" @click="titleShow = 1" type="text"/>
      <el-button class="edit" icon="el-icon-check" v-show="titleShow == 1 && !isDoctor" @click="modifyTitle('save')" type="text"/>
      <el-button class="edit" icon="el-icon-close" v-show="titleShow == 1 && !isDoctor" @click="modifyTitle('cancel')" type="text"/>
    </div>
    <div slot="btn">
      <el-button icon="el-icon-back" class="r90" @click="$router.push('/medicaltemplate/consultationquestionnairelist')">列表</el-button>
      <el-button icon="el-icon-refresh" @click="$refresh(getQuestionsList)">刷新</el-button>
    </div>
    <div slot="content" class="detailswrap">
      <!-- 操作按钮 -->
      <div class="button" v-if="!isDoctor">
        <el-button icon="el-icon-plus" type="primary" @click="addQuestions">新增题目</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteQuestionsList">批量删除</el-button>
      </div>
      <!-- 题目列表 -->
      <el-table v-loading="loading" :data="questionsList" :max-height="tableHeight" ref="multipleTable" @selection-change="val => $handleSelectionChange(val, true)">
        <el-table-column type="selection" width="50" v-if="!isDoctor"/>
        <el-table-column type="expand" width="30">
          <template slot-scope="props">
            <el-form label-position="right">
              <el-form-item label="题目名称"><span>{{ props.row.questionsTitle }}</span></el-form-item>
              <el-form-item label="题目类型"><span>{{ props.row.questionsType == 0 ? '单选' : '多选' }}</span></el-form-item>
              <el-form-item class="option" label="题目选项">
                <div v-for="(item, i) in props.row.answers" :key="item.examTemplateAnswerId">
                  {{ i + 1 }}. {{item.answerContent}}
                </div>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="questionsTitle" label="题目名称"/>
        <el-table-column prop="questionsType" label="题目类型">
          <template slot-scope="scope">
            {{ scope.row.questionsType == 0 ? '单选' : '多选' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope" v-if="!isDoctor">
            <el-button icon="el-icon-edit" type="primary" @click="editQuestions(scope.row)">编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteQuestions(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑或新增题目 -->
      <el-dialog class="questionsEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" label-width="80px" :rules="editFormRules" inline>
          <el-form-item label="题目名称" prop="questionsTitle">
            <el-input v-model="editForm.questionsTitle" placeholder="请输入题目名称"/>
          </el-form-item>
          <el-form-item label="题目类型" prop="questionsType">
            <el-radio-group v-model="editForm.questionsType">
              <el-radio :label="0">单选</el-radio>
              <el-radio :label="1">多选</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="option" label="题目选项" prop="answers">
            <div class="option-wrap">
              <el-form-item v-for="(item, i) in editForm.answers" :key="i" :label="'选项'+ (i+1)" :prop="'answers.' + i + '.answerContent'"
                :rules="[{required: true, message: '选项内容不能为空！', trigger: 'blur'}]">
                <el-input v-model="item.answerContent" placeholder="请输入选项内容" clearable/>
                <el-button icon="el-icon-delete" type="danger" @click="delAnswer(i)"/>
              </el-form-item>
            </div>
            <el-button icon="el-icon-plus" type="primary" @click="addOption">新建选项</el-button>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增题目'" @click="addSave(editForm)">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑题目'" @click="editSave(editForm)">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getQuestionsList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import { questionList, questionEdit, questionDelete, questionAdd, templateEdit } from "@/api/consultation-questionnaire"; // 获取问诊单请求
export default {
  name: "templates",
  data() {
    return {
      loading: true, // 加载中
      inquiryTemplateId: this.$route.query.id, // 随访问诊单id
      templateName: this.$route.query.templateName, // 随访问诊单标题
      templateNameCopy: this.$route.query.templateName, // 随访问诊单标题
      isDoctor: this.$route.query.isDoctor, // 是否医生查看公有模板
      questionsList: [], // 题目列表
      multipleSelection: [], // 被选中行
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        questionsTitle: [{ required: true, message: "题目名称不能为空！" }],
        questionsType: [{ required: true }],
        answers: [{ required: true }]
      }, // 验证规则
      questionOptions: [], // 题库问题
      dialogTitle: '', // 弹框标题
      titleShow: 0, // 标题是否修改 
      tableHeight: 0, // 表格最大高度
      searchForm: {}
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280; // 计算表格最大高度
    this.getQuestionsList(); // 请求题目列表
  },
  methods: {
    // 请求所有题目列表
    async getQuestionsList() {
      let { rows, code, total } = await questionList({pageNum: this.currentPage, pageSize: this.pageSize, inquiryTemplateId: this.inquiryTemplateId});
      if (code == 200) {
        this.questionsList = rows;
        this.total = total;
      }
      this.loading = false;
    },
    // 修改问诊单题目
    async modifyTitle(type) {
      if (type == 'save') {
        if (this.templateName == "") this.$message.error('问诊单标题不能为空，请修改后再试！');
        else if (this.templateName == this.templateNameCopy) this.titleShow = 0;
        else {
          let {code} = await templateEdit({id: this.inquiryTemplateId, templateName: this.templateName});
          if (code == 200) {
            this.$message.success('修改问诊单标题成功！');
            this.titleShow = 0;
          }
        }
      }
      this.titleShow = 0;
    },
    // 新增选项
    addOption() {
      this.editForm.answers.push({ answerContent: null });
    },
    // 删除选项
    delAnswer(i) {
      let list = this.editForm.answers;
      if (list.length == 1) this.$message('最后一项不能删除！');
      else list.forEach((item, index) => {
        if (index == i) list.splice(index,1)
      })
    },
    // 新增题目
    addQuestions() {
      this.dialogVisible = true;
      this.dialogTitle = '新增题目';
      this.editForm = { questionsTitle: null, questionsType: 0, inquiryTemplateId: this.inquiryTemplateId, answers: [{ answerContent: null }] };
    },
    // 保存新增
    addSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          questionAdd(obj).then(res => {
            if (res.code == 200) this.$message.success("新增题目成功！");
            this.dialogVisible = false;
            this.$refresh(this.getQuestionsList);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 编辑题目信息
    editQuestions(row) {
      this.dialogTitle = '编辑题目';
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    // 保存题目修改
    editSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          questionEdit(obj).then(res => {
            if (res.code == 200) this.$message.success("修改题目成功！");
            this.dialogVisible = false;
            this.$refresh(this.getQuestionsList);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 删除题目
    deleteQuestions(row) {
      this.$confirm('确认删除该题目？').then(_ => { this.del(row.id) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await questionDelete(id);
      if (code == 200) this.$message.success("删除题目成功！");
      this.$refresh(this.getQuestionsList);
    },
    // 批量删除题目
    deleteQuestionsList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何题目");
      else {
        selected.forEach(item => { selectedId.push(item.id) });
        this.$confirm('确认删除该题目？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    }
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  .edit {
    position: static;
    padding: 0;
    margin-left: 15px;
    font-size: 16px;
  }
}
/* 题目输入框样式 */
.title-input {
  display: inline;
  /deep/.el-input__inner {
    width: 200px!important;
  }
}
.detailswrap {
  & > div:not(:last-child) {
    margin-bottom: 20px;
  }
  /* 题目列表样式 */
  .el-table {
    border: 1px solid #e6e6e6;
    border-bottom: 0;
    .el-form {
      margin-left: 40px;
      .el-form-item {
        margin-bottom: 0;
        &.option {
          /deep/.el-form-item__content {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;
            div {
              width: 400px;
            }
          }
        }
        /deep/.el-form-item__content {
          font-size: 12px;
          line-height: 24px;
          padding-left: 72px;
          
     
        }
        /deep/.el-form-item__label {
          color: #999;
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
  }
  /* 题目模态框样式 */
  .questionsEdit {
    .option {
      .option-wrap {
        border: 1px solid #e6e6e6;
        padding: 0 7px;
        margin-bottom: 10px;
        .el-form-item {
          padding: 7px 0;
          margin: 0;
          &:not(:last-of-type) {
            border-bottom: 1px solid #e6e6e6;
          }
          /deep/.el-form-item__label {
            width: 60px!important;
          }
          /deep/.el-form-item__content {
            display: flex;
            .el-input {
              flex: 1;
              margin-right: 7px;
            }
          }
        }
      }
    }
    .el-form {
      .el-form-item {
        margin-right: 0;
        display: flex;
        /deep/.el-form-item__content {
          flex: 1;
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>